import styled, { css } from 'styled-components'
import { Text } from 'vvs-uikit'

export const TitleStyle = css`
  font-family: 'Soleil';
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 32px;
  color: ${({ theme }) => theme.colors.darkestNightBlue};
`

export const DescStyle = css`
  ${TitleStyle}
  font-weight: 350;
  font-size: 13px;
  line-height: 18px;
`
export const TokenPairText = styled(Text)`
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.text};
  margin-left: 10px;
`

export const TokenWrapper = styled.div`
  top: 4px;
  position: relative;
  padding-right: 8px;
  width: 50px;
`
